<template>
  <a-modal
    title="祺信详情"
    v-model="modalShow"
    width="80%"
    :footer="false"
    @cancel="close"
    destroyOnClose>
    <div style="margin-top:-20px;">
      <div class='gold-page'>
        <div class="common-title">祺信详情</div>
        <div class="page-main no-shadow">
            <div class="spaceBetween">
                <div>
                    <div class="gold-line">开立日：{{goldData.estbDay | dateFormat('YYYY-mm-dd')}}</div>
                    <div class="gold-line">到期日：{{goldData.exDay | dateFormat('YYYY-mm-dd')}}</div>
                </div>
                <div style="font-weight:bold;font-size:18px;position: relative;left:20px;">祺信</div>
                <div>
                    <div class="gold-line">状态：
                        {{goldData.isPledged == 1 ? (goldData.pledgeStatus | pledgeStatus)
                        : goldData.gldStCd | GbGldStCdTrans}}
                    </div>
                    <div class="gold-line">编号：{{goldData.gldId}}</div>
                </div>
            </div>
            <table class="gold-detail-table">
                <tr v-if="goldData.isPledged != 1">
                    <td>流转方</td>
                    <td>{{ goldData.pyptNm }}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ goldData.pyptOrgCode }}</td>
                </tr>
                <tr v-if="goldData.isPledged != 1">
                    <td>接收方</td>
                    <td>{{ goldData.rcPtyNm || goldData.tenantNm || goldData.tenantName}}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ goldData.rcPtyOrgCode || goldData.tenantOrgCode }}</td>
                </tr>
                <tr>
                    <td>开立方</td>
                    <td>{{ goldData.estbNm }}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ goldData.estbOrgCode }}</td>
                </tr>
                <tr v-if="goldData.grtStCd == 2">
                    <td>保证人</td>
                    <td>{{ goldData.guarantorName }}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ goldData.guarantorOrgCode }}</td>
                </tr>
                <tr v-if="goldData.isPledged == 1">
                    <td>出质人</td>
                    <td>{{ goldData.pledgorNm }}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ goldData.pledgorOrgCode }}</td>
                </tr>
                <tr v-if="goldData.isPledged == 1">
                    <td>质权人</td>
                    <td>{{ goldData.pledgeeName }}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ goldData.pledgeeOrgCode }}</td>
                </tr>
                <tr>
                    <td colspan="4" style="height:50px;">
                        <span>祺信金额</span>
                        <span style="margin-left:60px;">(大写){{ goldData.bigGldAmt }}</span>
                        <span style="margin-left:160px;">(小写)¥{{ goldData.gldAmt | splitK }}</span>
                    </td>
                </tr>
                <tr>
                    <td colspan="4">
                        <span>
                        开立方声明：我司已对本祺信出具《付款承诺函（{{goldData.firstGldId}}
                            ）》，到期无条件依据持票方明细付款。    承诺日期：{{ goldData.signTime | dateFormat('YYYY-mm-dd')}}
                        </span>
                    </td>
                </tr>
                <tr v-if="+goldData.isPledged !== 1">
                    <td colspan="4" class="detail-table__remarks">
                        <span v-if="+goldData.canBeModified === 0">备注：本祺信可以全部或部分流转支付<span v-if="goldData.firstGldId !== goldData.gldId">，也可以随时申请融资</span>。</span>
                        <span v-if="+goldData.canBeModified === 1 || +goldData.canBeModified === 3">备注：本祺信可以全部或部分流转支付<span v-if="goldData.firstGldId !== goldData.gldId">，也可以随时申请融资</span>。<b>开立方可对本祺信的到期日期进行变更，变更后的祺信到期日期将早于{{goldData.exDay | dateFormat('YYYY-mm-dd')}}。</b></span>
                        <span v-if="+goldData.canBeModified === 2">备注：本祺信可以全部或部分流转支付<span v-if="goldData.firstGldId !== goldData.gldId">，也可以随时申请融资</span>。<b>开立方已于{{goldData.modifiedDay | dateFormat('YYYY-mm-dd')}}，将到期日期由{{goldData.beforeModified|dateFormat('YYYY-mm-dd')}}变更为{{goldData.afterModified|dateFormat('YYYY-mm-dd')}}。</b></span>
                    </td>
                </tr>
                <tr v-if="+goldData.isPledged === 1">
                    <td colspan="4" class="detail-table__remarks">
                        <span>备注：本祺信已质押,清分款项需先用于偿还出质人的债务.</span>
                    </td>
                </tr>
            </table>
            <div class="spaceBetween" style="margin-top:10px;">
                <div>
                    <div class="gold-line">流转方财务记账建议：</div>
                    <div class="gold-line">借：银行存款、财务费用</div>
                    <div class="gold-line">贷：应收账款-祺信({{goldData.gldId}}） </div>
                </div>
            </div>
        </div>
      </div>
      <goldDetailOriginInfo :parentData="parentData" :goldData.sync="goldData"></goldDetailOriginInfo>
    </div>
  </a-modal>
</template>

<script>
import {mapGetters} from "vuex"
import goldDetailOriginInfo from "@/components/gold-page/gold-detail-origin-info"
import {getDetailApi} from '@/api/gold.js'
export default {
    components:{
      goldDetailOriginInfo
    },
    name:"goldFinancingDetail",
    data() {
        return {
            goldData:{},
            modalShow:false,
        };
    },
    computed:{
        ...mapGetters({
            parentData:"app/getGoldDetailPrarms"
        })
    },
    methods: {
        open(){
            this.getDetail();
            this.modalShow = true;
        },
        close(){
            this.goldData = {};
            this.modalShow = false;
        },
        getDetail(){ //融资申请点击查看祺信详情
            if(this.parentData.goldObj){
                let param = {...this.parentData.goldObj}
                getDetailApi(param,true)
                .then(res => {
                    this.goldData = res.data;
                }).catch(err => { console.log(err);});
            }
        }
    }
};
</script>
<style scoped>
  .gold-page{
      margin-top:20px;
  }
  .gold-line{
      margin-bottom: 4px;
      color:#737F8E;
  }
  .gold-detail-table{
      width: 100%;
      font-family: MicrosoftYaHei;
      border-collapse: collapse;
      padding: 0;
      font-weight: normal;
      color: #0D253E;
      letter-spacing: 0;
      border: 1px solid #E2ECF7;
  }
  .gold-detail-table td{
      padding: 10px 15px;
      box-sizing: border-box;
      border: 1px solid #E2ECF7;
  }
  .gold-detail-table td:first-child{
      padding-left: 53px;
      width: 140px;
  }
  .gold-detail-table td:nth-child(3){
      width: 150px;
  }
  .gold-btns{
      margin:10px 0 8px 0;
  }
  .gold-btns button{
      margin:0 10px;
  }
  .btn-blue-line-detail{
      background:#F1FBFF;
      border-color: #91D5FF;
  }
  .btn-blue-line-detail:hover{
      background: #1990FF;
      color:#fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/circulation/gold-financing/financing-gold-detail-model.vue